export const environment = {
  production: true,
  name: 'production',
  apiURL: 'https://api-platform.migopayments.com/platform',
  authHeaderName: 'Authorization',
  sentryDsn:
    'https://74dd1cc4f24f42b09453d0856a65526e@o1080520.ingest.sentry.io/6264629',
  appKey: 'c74df135f749f2c38cbd071b9060010623eda8062b3959a22b965ba216b0146f',
  googleAnalyticsId: 'G-GZRNM6KBVC',
  generateEndpoint: (segments: any[]) =>
    environment.apiURL + '/' + segments.join('/'),
  betaURL: 'https://beta-platform.migopayments.com',
  currentURL: 'https://platform.migopayments.com',
  voucherPath:
    'https://s3.us-east-1.amazonaws.com/docs.migopayments.com/vouchers-prod',
  migoMwURL: 'https://mw.migopayments.com',
  migoMwSubscriptions: {
    getPlansByClient: '/api/v1/plans/list?client={clientId}',
  },
  migoMwPrivateKey: 'YIBw9mf7JD7ogUU3JWda1',
  migoMwPublicKey: 'zw-s1Jn32TzkJ0y_2yQed',
  migoWebviewUrl: 'https://web.migopayments.com/',
};
